import { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';

export const VideoModal = ({ open, onClose, src, poster, title, subtitle }) => {
    useEffect(() => {
        if (!open) return;
        const onKey = (e) => e.key === 'Escape' && onClose();
        window.addEventListener('keydown', onKey);
        document.body.style.overflow = 'hidden';
        return () => {
            window.removeEventListener('keydown', onKey);
            document.body.style.overflow = '';
        };
    }, [open, onClose]);

    return (
        <AnimatePresence>
            {open && (
                <motion.div
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    transition={{ duration: 0.4 }}
                    data-testid="video-modal"
                    className="fixed inset-0 z-[100] bg-ink/95 backdrop-blur-xl flex flex-col"
                    onClick={onClose}
                >
                    <div className="flex items-center justify-between px-6 md:px-12 py-6 border-b border-white/5">
                        <div>
                            <p className="text-[10px] uppercase tracking-[0.4em] text-gold">
                                Now Playing
                            </p>
                            <h3 className="font-serif text-bone text-xl md:text-2xl mt-1 tracking-tight">
                                {title}
                            </h3>
                            {subtitle && (
                                <p className="text-[11px] uppercase tracking-[0.3em] text-bone-dim mt-1">
                                    {subtitle}
                                </p>
                            )}
                        </div>
                        <button
                            data-testid="video-modal-close"
                            onClick={onClose}
                            aria-label="Close"
                            className="w-12 h-12 border border-white/15 flex items-center justify-center text-bone hover:border-gold hover:text-gold transition-colors"
                        >
                            <X size={20} />
                        </button>
                    </div>

                    <motion.div
                        initial={{ scale: 0.96, opacity: 0 }}
                        animate={{ scale: 1, opacity: 1 }}
                        transition={{ delay: 0.1, duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
                        className="flex-1 flex items-center justify-center p-6 md:p-12"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <div className="w-full max-w-6xl aspect-video bg-black overflow-hidden shadow-2xl shadow-black/60">
                            <video
                                src={src}
                                poster={poster}
                                controls
                                autoPlay
                                playsInline
                                data-testid="video-modal-player"
                                className="w-full h-full object-contain bg-black"
                            />
                        </div>
                    </motion.div>
                </motion.div>
            )}
        </AnimatePresence>
    );
};
